export const strokeWidth = (index, validRating) => index > validRating ? 1.25 : 1;
export const stroke = (index, hoverState, validRating, color) => {
  const grey = 'var(--control-secondary)';
  if (hoverState) {
    return index > hoverState ? grey : color;
  }
  return index <= validRating ? color : grey;
};
export const isInputChecked = (index, validRating) => index === validRating;
export const checkRating = rating => {
  if (rating > 0) {
    return rating < 5 ? +rating.toFixed(1) : 5;
  }
  return 0;
};